export default __webpack_public_path__ + "static/media/therapy_brain_fake.b95d1f21.png";